import React from 'react'
import { Container, Row, Col, Form } from 'reactstrap'
import ICSVehiclePicker from '../../../components/ICSVehiclePicker/ICSVehiclePicker'
import { useForm } from 'react-hook-form'
import ICSDateRange from '../../../components/ICSDateRange/ICSDateRange'
import { FileExtensionPicker } from './FileExtensionPicker'
import ComponentBox from '../../../components/ComponentBox/ComponentBox'
import { useDispatch } from 'react-redux'
import { DataSearchRequest } from '../../../services/endpoints/data'
import { searchDataThunk } from '../../../redux/slices'
import { Collection } from './CollectionPicker'
import ICSButton from '../../../components/ICS/Button/ICSButton'
import { DataSpyEnabled } from './DataSpyEnabled'
import { SearchSettings } from './SearchSettings'
import { useTimezone } from '../../../hooks/useTimezone'
import "./SearchBox.css"

export interface _DataSearchValues {
    vehiclePicker: {
        fleets: string[],
        vehicles: string[]
    },
    dateRange: {
        start: string | null,
        end: string | null
    },
    collections: string[],
    fileTypes: string[],
    max: number
}

const SearchBox: React.FC = () => {
    const { handleSubmit, control, register, formState: { isSubmitting, isValid, isDirty } } = useForm<_DataSearchValues>({
        defaultValues: {
            vehiclePicker: {
                fleets:[],
                vehicles: []
            },
            dateRange: {
                start: null,
                end: null
            },
            collections: [],
            fileTypes: [],
            max: 50
        }
    })
    const dispatch = useDispatch()
    const { formatUtcTimeFromLocal } = useTimezone()
    
    const searchData = (data: _DataSearchValues) => {
        const req:DataSearchRequest = {
            fleetId: data.vehiclePicker.fleets,
            vehicleId: data.vehiclePicker.vehicles,
            extensions: data.fileTypes,
            names: data.collections,
            startDate: formatUtcTimeFromLocal(data.dateRange.start),
            endDate: formatUtcTimeFromLocal(data.dateRange.end),
            sort: 'uploadId',
            order: 'desc',
            offset: 0,
            max: data.max,
            onlyGroups: true
        }

        dispatch(searchDataThunk(req))
    }

    /** some testing and a reminder when RHF gets fixed for the ICSVehiclePickerProps issue (and others)
    const t = <T, K extends Path<T>>(v: PathValue<T, K>) => v
    const x = t<_DataSearchValues, "vehiclePicker">({vehicles: [], fleets: []})
    type Test = PathValue<_DataSearchValues, "vehiclePicker">
    //*/


    return (
        <Container fluid={true}>
             <Form onSubmit={handleSubmit(searchData)}> 
                    <ComponentBox isCustom={true} cardClass='groups-results-container' cardBodyId='groupsCardBody' title="Search Criteria" accordion={true}>
                        <Row>
                            <Col xs={12} md={6} >
                                <ICSVehiclePicker<_DataSearchValues, "vehiclePicker">
                                    name="vehiclePicker"
                                    control={control}
                                />
                            </Col>
                            <Col xs={12} md={6} >
                                <div>
                                    <div className="spacer">
                                        <h4>Date Range</h4>
                                        <ICSDateRange name="dateRange" control={control} />
                                    </div>
                                    <div className="spacer">
                                        <h4>Collection or File Name</h4>
                                        <Collection name="collections" control={control} />
                                    </div>
                                    <div className="spacer">
                                        <h4>File Extensions</h4>
                                        <FileExtensionPicker name="fileTypes" control={control} />
                                    </div>
                                </div> 
                            </Col>
                        </Row>
                        <Row className='dataSearchButtonsRow'>
                            <Col className='dataSearchButtonCol'>
                                <DataSpyEnabled />
                                <SearchSettings />
                            </Col>
                            <Col className='col-sm-auto dataSearchButtonCol'>
                                <ICSButton
                                    className='dataSearchButton'
                                    icon="search"
                                    text="Search"
                                    type="success"
                                    onClick={handleSubmit(searchData)}
                                    disabled={ isSubmitting || !isValid || !isDirty } 
                                />
                                <select className='ml-1 dataSearchMaxSelect form-control' {...register("max")}>
                                    {[5, 10, 25, 50].map(i => {
                                        return <option value={i}>{i}</option>
                                    })}
                                </select>
                            </Col>
                        </Row>
                </ComponentBox>   
            </Form> 
        </Container>
    )
}

export default SearchBox
